import { useParams, useNavigate, Link } from "react-router-dom";
import { vacancies } from "../../../components/vacancies/VacancyData";
import NotFound from "../../notfound/NotFound";
import {
  BackButton,
  ContactButton,
  SolliciteerButton,
  VacancyDetailsContent,
  VacancyDetailsPageContainer,
  VacancyDetailsPageTable,
  VacancyDetailsPageTitle,
  VacancyDetailsResultCard,
} from "./VacancyDetailsStyles";
import {
  VacancyIcon,
  VacancyIconWrapper,
} from "../../../components/vacancies/VacanciesStyles";
import {
  faCircleInfo,
  faClock,
  faEuroSign,
  faGraduationCap,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import Newsletter from "../../../components/newsletter/Newsletter";
import Footer from "../../../components/footer/Footer";

function VacancyDetails() {
  const { vacancyId } = useParams();
  const navigate = useNavigate();
  const vacancy = vacancies.find((v) => v.id === parseInt(vacancyId, 10));

  if (!vacancy) {
    return <NotFound />;
  }

  const handleBackButton = () => {
    navigate("/healthcare/vacancy");
  };

  const handleApplyButtonClick = () => {
    // Navigate to Apply page and pass the title as state
    navigate("/apply", { state: { title: vacancy.title } });
  };

  return (
    <VacancyDetailsPageContainer>
      <VacancyDetailsPageTable>
        <VacancyDetailsPageTitle>Vacature</VacancyDetailsPageTitle>
        <VacancyDetailsResultCard style={{ color: "#17224d" }}>
          <h2 style={{ color: "#17224d" }}>{vacancy.title}</h2>
          <VacancyDetailsContent>{vacancy.description}</VacancyDetailsContent>
          <p>
            <VacancyIconWrapper>
              <VacancyIcon icon={faLocationDot} />
            </VacancyIconWrapper>
            {vacancy.location}
          </p>
          <p>
            <VacancyIconWrapper>
              <VacancyIcon icon={faClock} />
            </VacancyIconWrapper>
            {vacancy.hours}
          </p>
          <p>
            <VacancyIconWrapper>
              <VacancyIcon icon={faEuroSign} />
            </VacancyIconWrapper>
            {vacancy.salary}
          </p>
          <p>
            <VacancyIconWrapper>
              <VacancyIcon icon={faCircleInfo} />
            </VacancyIconWrapper>
            {vacancy.info}
          </p>
          <p>
            <VacancyIconWrapper>
              <VacancyIcon icon={faGraduationCap} />
            </VacancyIconWrapper>
            {vacancy.education}
          </p>

          {/* Buttons */}
          <div className="buttons-container">
            <SolliciteerButton onClick={handleApplyButtonClick}>Solliciteer</SolliciteerButton>
            <Link to="/contact" style={{ textDecoration: "none" }}>
              <ContactButton>Contact</ContactButton>
            </Link>
            <BackButton onClick={handleBackButton}>
              Terug naar alle vacatures
            </BackButton>
          </div>
        </VacancyDetailsResultCard>
      </VacancyDetailsPageTable>

      {/* Healthcare - Vacancy: Newsletter */}
      <Newsletter />

      {/* Healthcare - Vacancy: Footer */}
      <Footer />
    </VacancyDetailsPageContainer>
  );
}

export default VacancyDetails;
